import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import {ApiService, CustomHttpParams} from 'src/app/services/api.service';
import {LoaderComponent} from "../../common/loader/loader.component";
import {RegisteredReportsSubModel, VenViewModel} from 'src/app/model/vens.model';

@Component({
  selector: 'app-send-report',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, LoaderComponent],
  templateUrl: './send-report.component.html',
  styleUrl: './send-report.component.scss'
})
export class SendReportComponent implements OnInit {
  protected isLoading: boolean = false;
  protected registered_reports: RegisteredReportsSubModel[] = [];
  protected vens: VenViewModel[] = [];

  protected result: any = {
    num_rids: 0,
    expected: 0,
    available: 0,
    missing: 0,
    updated: 0,
    succeeded: 0,
    ven: {
      id: 0
    },
    report_request: {
      report_id: null,
    }
  };

  protected status = 'Waiting.';
  protected venSelected: VenViewModel | undefined;
  protected registeredReportsSelected: any;

  constructor(private injector: Injector, private authService: AuthService, private sendReportService: ApiService) {}

  ngOnInit(): void {
    this.isLoading = true;
    const queryParams: CustomHttpParams = {
      'depths': JSON.stringify({
        "registered_reports": 1,
      }),
    };
    this.sendReportService.findVens(queryParams).subscribe((response: VenViewModel[]) => {
      this.vens = response.filter((ven: VenViewModel) => ven.registered_reports?.length > 0 && !ven.paused);
      this.isLoading = false;
    });
  }

  performAction() {
    this.isLoading = true;
    this.sendReportService.sendReport(this.registeredReportsSelected, this.venSelected?.id).subscribe({
      next: (response: any) => {
        this.result = response;
        this.status = 'Finished.';
        this.isLoading = false;
      },
      error: (err: any) => {
        this.status = 'Failed.';
        console.error(err);
        this.isLoading = false;
      }
    });
  }

  setVens(event: any) {
    this.venSelected = this.vens.find((ven: VenViewModel) => ven.id === Number(event.value));
    this.registered_reports = this.venSelected?.registered_reports ?? [];
  }

  registeredReport(event: any) {
    this.registeredReportsSelected = event.value;
  }
}
